import React from 'react'
import styles from "./MyProducts.module.css"

const MyProducts = () => {
    return (
        <div className={styles.block}>
        </div>
    )
}

export default MyProducts
